<template>
  <div class="warpper">
    <!-- 新增选择药品 -->
    <div class="content">
      <el-form
        ref="formData"
        label-width="120px"
        :rules="rules"
        :model="formData"
      >
        <el-form-item v-model="formData.name" label="所选药品">
          <p>{{ formData.name }}</p>
        </el-form-item>
        <el-form-item v-model="formData.actualSpecs" label="药品规格">
          <p>{{ formData.actualSpecs }}</p>
        </el-form-item>
        <el-form-item v-model="formData.packingSpecs" label="包装规格">
          <p>{{ formData.packingSpecs }}</p>
        </el-form-item>
        <el-form-item label="单次用量" prop="dose">
          <div style="display: flex">
            <el-input
              v-model="formData.dose"
              :min="0"
              type="number"
              style="width: 45%"
              placeholder="药量"
            ></el-input>
            <el-form-item prop="doseUnitValue">
              <el-select
                v-model="formData.doseUnitValue"
                filterable
                style="width: 45%"
                placeholder="单位"
              >
                <el-option
                  v-for="item,key in DRUG_UNIT"
                  :key="key"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="数量" prop="drugNum">
          <el-input-number
            size="mini"
            v-model="formData.drugNum"
          ></el-input-number>
          &nbsp; {{ formData.packUnit }}
        </el-form-item>
        <el-form-item label="用药天数" prop="useDays">
          <el-input
            type="number"
            style="width: 220px"
            v-model="formData.useDays"
            placeholder="请输入用药天数"
            max="30"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="给药频率" prop="frequencyUnitValue">
          <el-select
            v-model="formData.frequencyUnitValue"
            value-key="id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in drug_list.frequency"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="给药途径" prop="drugDirections">
          <el-select
            v-model="formData.drugDirections"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in drug_list.route"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补充说明(选填)" prop="adUsage">
          <el-input
            style="width: 220px"
            v-model="formData.adUsage"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="foo">
            <el-button type="primary" @click="setData()">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script type="text/javascript">
import { addDictMap } from '@/api';
import { DRUG_UNIT } from '@/utils/constants.js';

export default {
  name: 'drugPanelForm',
  props: {
    formShow: Boolean,
    drugItem: {
      type: Object,
      default: () => {},
    },
    drugNumSpcesObjAll: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validatePass = (rule, value, callback) => {
        if (value > 30 || value < 1) {
          callback(new Error('请填写用药天数，用药天数大于0小于30'));
        } else {
          callback();
        }
      };
    return {
      DRUG_UNIT,
      edit: 0, // 0为新增，1为编辑
      formData: {}, // 接口参数
      drug_list: {}, // 药品信息列表
      rules: {
        specs: [{ required: true, message: '请选择药品规格', trigger: 'blur' }],
        drugNum: [
          { required: true, message: '请选择药品数量', trigger: 'blur' },
        ],
        dose: [
          { required: true, message: '请选择药品单次用量', trigger: 'blur' },
        ],
        doseUnitValue: [
          { required: true, message: '请选择单位', trigger: 'change' },
        ],
        useDays: [
          { validator: validatePass, message: '请填写用药天数，用药天数大于0小于30', trigger: 'change' },
        ],
        frequencyUnitValue: [
          { required: true, message: '请选择频率', trigger: 'change' },
        ],
        drugDirections: [
          { required: true, message: '请选择药品途径', trigger: 'change' },
        ],
      },
    };
  },
  mounted() {
    this.formData = this.drugItem;
    this.resetForm();
    this.getDictlist();
  },
  methods: {
    async getDictlist() {
      // 药品信息--药品字典
      let res = await addDictMap();
      if (res.code == 1) {
        this.drug_list = res.data;
      }
    },
    resetForm() {
      // 清空表单
      this.$refs.formData.resetFields();
    },
    setData() {
      // 保存表单
      this.$refs.formData.validate((valid) => {
        if (valid) {
          const drugs = {
            name: this.formData.name,
            actualSpecs: this.formData.actualSpecs,
            packingSpecs: this.formData.packingSpecs,
          };
          const recipeDrugs = {
            dose: this.formData.dose,
            drmodel: this.formData.drmodel,
            drugNum: this.formData.drugNum,
            packUnit: this.formData.packUnit,
            doseUnitValue: this.formData.doseUnitValue,
            frequencyUnitValue: this.formData.frequencyUnitValue,
            drugDirections: this.formData.drugDirections,
            useDays: this.formData.useDays,
            adUsage: this.formData.adUsage,
          };
          this.formData.drugs = drugs;
          this.formData.recipeDrugs = recipeDrugs;
          this.$emit('on-drug-add', this.formData);
        }
      });
    },
  },
  watch: {
    drugItem(curVal, oldVal) {
      this.formData = curVal;
    },
  },
};
</script>
<style lang="scss" type="text/css">
.warpper {
  min-height: 570px;

  .content {
    display: flex;
    margin: 20px 0 0 0;
  }
}
</style>
